import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import { FormInput_text, FormRadio } from "components";

import ic_expand_more from "assets/images/ic_expand_more.svg";

import { func_validation, getArrayLength, getObjectPropertyValue, getStringUniqueId, isArrayNotEmpty, isFunction, isNotNullUndefined, isNullUndefined, isNumberValid, isStringTrimEmpty, isStringTrimNotEmpty } from 'functions';

import 'assets/scss/components/filters/dropdown.scss';
import { Toaster } from 'components/notification/Toaster';
import { Spinner } from 'components/loaders/Spinner';



export function Dropdown(props) {
    const { 
        className, 
        labelClassName, label, isInputRequired, isInputDigitOnly, isOptionRadio, isUpdatingLabel_fromParent,
        selectedValueIconClassName, selectedValueWrapperClassName, selectedValueClassName, arrowClassName, 
        isSelectedValueIconVisible, options: options_props, valueFromParent, selectedValue_default, selectedValueLabel_default,
        placeholder: placeholder_props, isFormSubmissionAttempted,
        isListLoading,
        errorMsg, customErrorValidation,
        isSearchable, isDisabled, isResetRequired, isSortingOptional,
        disabledInputMsg,

        // Functions
        onEnterKeyPressed = () => {}
    } = props;

    // Props Validation
    let label_validated = isStringTrimNotEmpty(label)? label: "";
    let errorMsg_validated = isStringTrimNotEmpty(errorMsg)? errorMsg: "";
    let options = isArrayNotEmpty(options_props) && !isSortingOptional? options_props.sort((obj, obj1) => obj.label > obj1.label? 1:-1):options_props;

    // States

    let selectedValueLabel_init = isStringTrimNotEmpty(selectedValueLabel_default)? selectedValueLabel_default:
        (isNotNullUndefined(selectedValue_default)? 
            getLabelFromOptions(selectedValue_default):"");
    const [selectedValueLabel, setSelectedValueLabel] = useState(selectedValueLabel_init);
    const [selectedValue, setSelectedValue] = useState(selectedValue_default);
    const [isOptionListVisible, setOptionListVisibility] = useState("");

    const [componentUniqueId] = useState(getStringUniqueId("component-dropdown"));
    const [optionUniqueIds, setOptionUniqueIds] = useState([]);
    const [optionEleId] = useState(getStringUniqueId("component-dropdown-optionList"));
    const [inputWrapperUniqueId] = useState(getStringUniqueId("component-dropdown-selectedValueWrapper"));
    const [inputUniqueId] = useState(getStringUniqueId("component-dropdown-selectedValueWrapper-input"));
    const [arrowIconUniqueId] = useState(getStringUniqueId("component-dropdown-arrow"));

    const [optionList, setOptionList] = useState([]);
    const [optionTraversingIndex, setOptionTraversingIndex] = useState();
    const [visibleScrollHeight_top, setVisibleScrollHeight_top] = useState();
    const [visibleScrollHeight_bottom, setVisibleScrollHeight_bottom] = useState();


    function getLabelFromOptions(value) {
        let arraySize = getArrayLength(options, 0);
        for(let i = 0; i < arraySize; i++) {
            let optionValue = getObjectPropertyValue(options[i], "value");
            if (value == optionValue) {
                let label = getObjectPropertyValue(options[i], "label");
                return label;
            }
        }
        return value;
    }

    function getValueFromOptions(label) {
        let arraySize = getArrayLength(options, 0);
        for(let i = 0; i < arraySize; i++) {
            let optionLabel = getObjectPropertyValue(options[i], "label");
            if (label === optionLabel) {
                let value = getObjectPropertyValue(options[i], "value");
                return value;
            }
        }
        return label;
    }

    function updateState(label, value, index) {
        setSelectedValueLabel(label);
        setSelectedValue(value);
        setOptionTraversingIndex(undefined);

        if (props.onChange) props.onChange(value, label, index);
    }
    function updateDefaultStateFromParent() {        
        if (isStringTrimEmpty(selectedValueLabel) &&
            isNotNullUndefined(selectedValueLabel_default)) {
            setSelectedValueLabel(selectedValueLabel_default);
        }
        else if (isStringTrimEmpty(selectedValue) &&
            isNotNullUndefined(selectedValue_default)) {
            setSelectedValueLabel(getLabelFromOptions(selectedValue_default));
        }

        if (isUpdatingLabel_fromParent &&
            isNotNullUndefined(selectedValueLabel_default)) {
            setSelectedValueLabel(selectedValueLabel_default);
        }
    }
    function updateStateFromParent() {
        if (isNotNullUndefined(valueFromParent)) {
            setSelectedValueLabel(getLabelFromOptions(valueFromParent));
            setSelectedValue(valueFromParent);
        }
    }
    function updateStateFromParent_optionList() {
        if (isArrayNotEmpty(options)) {
            setOptionList(options);

            let uniqueIdList = options.map((itemObj, idx) => {
                return getStringUniqueId("option" + idx);
            });
            setOptionUniqueIds(uniqueIdList);
        }
    }
    useEffect(() => {
        updateDefaultStateFromParent();
    }, [selectedValue_default, selectedValueLabel_default]);
    useEffect(() => {
        updateStateFromParent();
    }, [valueFromParent, JSON.stringify(options)]);
    useEffect(() => {
        updateStateFromParent_optionList();
    }, [JSON.stringify(options)]);

    useEffect(() => {
        if (isResetRequired) {
            let value = isStringTrimNotEmpty(selectedValue_default)? selectedValue_default: "";
            setSelectedValueLabel(selectedValueLabel_default? selectedValueLabel_default: getLabelFromOptions(value));
            setSelectedValue(value);
        }
    }, [isResetRequired]);

    function handleOnEnterKeyPressed(value) {
        if (isNumberValid(optionTraversingIndex)) {
            // Get value & label from list again based on traversing index.
            let item = optionList[optionTraversingIndex];
            let value = getObjectPropertyValue(item, "value");
            let label = getObjectPropertyValue(item, "label");
            updateState(label, value);

            onEnterKeyPressed(value);
        }
        else {
            updateState(getLabelFromOptions(value), value);
            onEnterKeyPressed(value);
        }
    }
    function handleOnEnterKeyDown(e, value) {
        let traversingIndex_new = 0;
        let isTraversingIndexValueUpdated = false;

        // Backspace Key
        if (isNumberValid(e.keyCode) && e.keyCode == 8) {
            setSelectedValue(value);
            setSelectedValueLabel(getLabelFromOptions(value));
        }

        // Down Arrow Key
        if (isNumberValid(e.keyCode) && e.keyCode == 40) {
            if (isNullUndefined(optionTraversingIndex)) {
                setOptionTraversingIndex(traversingIndex_new);
                isTraversingIndexValueUpdated = true;
            }
            else if ((getArrayLength(optionList) - 1) > optionTraversingIndex) {
                traversingIndex_new = optionTraversingIndex + 1;
                setOptionTraversingIndex(traversingIndex_new);
                isTraversingIndexValueUpdated = true;
            }
        }
        // Up Arrow Key
        else if (isNumberValid(e.keyCode) && 
            e.keyCode == 38 &&
            (optionTraversingIndex) &&
            optionTraversingIndex > 0) {

            traversingIndex_new = optionTraversingIndex - 1;
            setOptionTraversingIndex(traversingIndex_new);
            isTraversingIndexValueUpdated = true;
        }

        // Scroll to the traversing item
        let optionEle = document.getElementById(optionEleId);
        let optionItemEle = document.getElementById(optionUniqueIds[traversingIndex_new]);
        if (isTraversingIndexValueUpdated &&
            isNotNullUndefined(optionEle) && 
            isNotNullUndefined(optionItemEle)) {

            let optionComputedStyle = window.getComputedStyle(optionEle);
            let option_height_string = optionComputedStyle.getPropertyValue("height").replace("px","");
            let option_height = parseInt(option_height_string);

            let optionItemComputedStyle = window.getComputedStyle(optionItemEle);
            let optionItem_height_string = optionItemComputedStyle.getPropertyValue("height").replace("px","");
            let optionItem_height = parseInt(optionItem_height_string);
            let optionItem_offsetTop = optionItemEle.offsetTop;
            let optionItem_offsetBottom = optionItem_offsetTop + optionItem_height;

            if (isNullUndefined(visibleScrollHeight_bottom)) {
                setVisibleScrollHeight_top(0);                
                setVisibleScrollHeight_bottom(option_height);                
            }
            else if (isNumberValid(visibleScrollHeight_bottom) &&
                optionItem_offsetBottom > visibleScrollHeight_bottom) {

                optionEle.scrollTop = optionItem_offsetBottom - option_height;

                setVisibleScrollHeight_top(optionEle.scrollTop);
                setVisibleScrollHeight_bottom(optionItem_offsetBottom);
            }
            else if (isNumberValid(visibleScrollHeight_top) &&
                optionEle.scrollTop > optionItem_offsetTop) {

                optionEle.scrollTop = optionItem_offsetTop;

                setVisibleScrollHeight_top(optionItem_offsetTop);
                setVisibleScrollHeight_bottom(optionItem_offsetTop + option_height);
            }
        }
    }

    // Placeholder
    let placeholder = isStringTrimNotEmpty(placeholder_props)? placeholder_props: "Select...";

    // Option List
    function updateOptions(value) {
        if (isArrayNotEmpty(options) &&
            isNotNullUndefined(value)) {
                
            let optionList_new = [];
            let value_lowercase = (value + "").toLowerCase();
            options.map((item) => {
                let label = getObjectPropertyValue(item, "label", "") + "";
                let label_lowercase = label.toLowerCase();
                if (label_lowercase.match(value_lowercase))
                    optionList_new.push(item);
            });
            setOptionList(optionList_new);
        }
    }
    function toggleOptionsVisibility(isVisible) {
        let isVisible_formatted = !isOptionListVisible;
        if (isNotNullUndefined(isVisible)) isVisible_formatted = isVisible;

        setOptionListVisibility(isVisible_formatted);
    }
    let optionArray = [];
    const selectedItemIndex = useRef();
    if (isArrayNotEmpty(optionList)) {
        optionArray = optionList.map((details, idx) => {
            let label = getObjectPropertyValue(details, "label","");
            let value = getObjectPropertyValue(details, "value","");
            let groupName = getObjectPropertyValue(details, "groupName","");
            let isItemFocused = (optionTraversingIndex == idx) || label == selectedValueLabel;
            if (label == selectedValueLabel) selectedItemIndex.current = idx;

            let isNotSelectable = details?.isNotSelectable;
            let notSelectableMsg = details?.notSelectableMsg;
    
            return (
                <div key={idx}
                    id={optionUniqueIds[idx]}
                    className={"component-dropdown-optionList-option d-flex align-items-center " +
                        (isItemFocused? "component-dropdown-optionList-option_traversing ":"")}
                    onMouseDown={() => { 
                        if (!isNotSelectable) 
                            updateState(label, value, idx); 
                        else if (notSelectableMsg)
                            Toaster({
                                type: "error",
                                msg: notSelectableMsg
                            })
                    }}
                >
                    {isOptionRadio? (
                        <FormRadio 
                            labelClassName={"component-dropdown-optionList-option-radio"}

                            radioGroupName={groupName}
                            radioValue={value}
                            radioLabel={label}
                            isSelected={selectedValue === value}
                        />
                    ):label}
                </div>
            );
        });
    }

    let ele = isNumberValid(selectedItemIndex.current)? document.getElementById(optionUniqueIds[selectedItemIndex.current]):undefined;
    let optionEle = document.getElementById(optionEleId);
    useEffect(() => {
        if (ele && optionEle) {
            optionEle.scrollTo(0, ele.offsetTop);
        }
    }, [isOptionListVisible, ele])

    let isErrorPresent = isFormSubmissionAttempted && 
        (isNullUndefined(selectedValue) || isStringTrimEmpty(selectedValue)) &&
        (errorMsg_validated != "");
    if (customErrorValidation) isErrorPresent = customErrorValidation;

    // Handle Option List Visiblity
    function handleComponentOnBlur(e) {
        let arrowIcon = document.getElementById(arrowIconUniqueId);
        let inputEle = document.getElementById(inputUniqueId);

        // Entire Component on blur
        if ((e.target != arrowIcon) &&
            (e.target != inputEle)) {

            toggleOptionsVisibility(false);
        }

        // Set Focus
        if ((e.target == inputEle) || 
            (e.target == arrowIcon)) 
            inputEle.focus();
    }
    useEffect(() => {
        window.addEventListener("click", handleComponentOnBlur);
        return () => {
            window.removeEventListener("click", handleComponentOnBlur);
        }
    }, []);

    // Option Position
    function handleOptionPosition() {
        const { isOptionPosition_up } = props;

        if (isOptionListVisible) {
            if (isOptionPosition_up) {
                let optionEle = document.getElementById(optionEleId);

                if (optionEle) {
                    let optionComputedStyle = window.getComputedStyle(optionEle);
                    let optionHeight = optionComputedStyle.getPropertyValue("height").replace("px", "");
                    optionEle.style.top = -optionHeight + "px";
                }
            }
        }
    }
    useEffect(() => {
        handleOptionPosition();
    }, [isOptionListVisible])

    return (
        <div id={componentUniqueId}
            className={"component-dropdown " + 
                (className? className + " ":"")}
            onClick={() => { 
                if (!isDisabled && isFunction(props.onClick))
                    props.onClick();

                if (isDisabled && isStringTrimNotEmpty(disabledInputMsg)) {
                    Toaster({
                        type: "info",
                        msg: disabledInputMsg
                    })
                }
            }}
        >
            {/* Label */}
            {label_validated? (
                <div className={"component-dropdown-labelWrapper " +
                        (labelClassName? labelClassName + " ":"")}>
                    <span className={"component-dropdown-label"}>{label_validated}</span>
                    {isInputRequired? (<span className={"component-dropdown-label-requiredSymbol"}>*</span>):""}
                </div>
            ):""}

            {/* Selected Value Display */}
            <div id={inputWrapperUniqueId} 
                className={"component-dropdown-selectedValueWrapper d-flex align-items-center justify-content-between " +
                            (selectedValueWrapperClassName? selectedValueWrapperClassName + " ":"") +
                            (isErrorPresent? "component-dropdown-selectedValueWrapper_errorBorder ":"") +
                            (isDisabled? "component-dropdown-selectedValueWrapper_disabled":"")}>

                {/* Icon */}
                {isSelectedValueIconVisible? (
                    <FontAwesomeIcon 
                        className={"component-dropdown-selectedValueWrapper-icon " +
                            (selectedValueIconClassName? selectedValueIconClassName + " ":"")} 
                        icon={faCircle}
                    />
                ):""}

                {/* Selected Value */}
                <FormInput_text
                    className={"component-dropdown-selectedValueWrapper-inputWrapper"}
                    customInputClassName={"component-dropdown-selectedValueWrapper-input " + 
                        (selectedValueClassName? selectedValueClassName + " ":"") +
                        (isSearchable? "":"component-dropdown-selectedValueWrapper-input_noCursor ")}
                    
                    inputPlaceholder={placeholder}
                    inputValue={isSearchable? selectedValue: selectedValueLabel}
                    inputCustomOptions={{ id: inputUniqueId }}
                    isInputDisabled={isDisabled}
                    
                    handleInputClickExtend={() => {
                        if (isSearchable) toggleOptionsVisibility(true);
                        else toggleOptionsVisibility(); 

                        setOptionTraversingIndex(undefined);
                    }}
                    isInputClickHandlingRequired

                    propagateValueBlur={(stateName, value) => {
                        if (props.onBlur) props.onBlur(value);
                    }}
                    isInputBlurHandlingRequired

                    propagateValueChange={(stateName, value) => { 
                        let newValue = "", newLabel = "";
                        if (isSearchable) {
                            newValue = value;
                            newLabel = getLabelFromOptions(value);
                        }
                        else {
                            newValue = getValueFromOptions(value);
                            newLabel = value;
                        }
                        
                        updateOptions(newValue);

                        // Update value
                        setSelectedValue(newValue);
                        setSelectedValueLabel(newLabel);
                        if (props.onChange) props.onChange(newValue, newLabel);
                    }}

                    handleInputEnterKeyPress={handleOnEnterKeyPressed}
                    isInputKeyPressHandlingRequired
                    isFocusRemovedOnEnterKey

                    handleInputKeyDown={handleOnEnterKeyDown}
                    isInputKeyDownHandlingRequired
                    
                    isInputDigitOnly={isInputDigitOnly}
                    isConvertedToNumber={isInputDigitOnly}
                    minInputDigit={props.minInputDigit}
                    minInputDigit_invalidMsg={props.minInputDigit_invalidMsg}
                    
                    isReadOnly={isSearchable? false: true}
                    isLabelOptional isInputOptional isMarginBtmOptional
                    isErrorOptional isErrorMsgOptional                     
                    isInputValueTrim_onChange={props.isInputValueTrim_onChange}
                />

                {/* Arrow */}
                <div className={"component-dropdown-arrow " +
                        (isDisabled? "component-dropdown-arrow_disabled ":"") +
                        (arrowClassName? arrowClassName + " ":"")}
                    onClick={() => {
                        if (!isDisabled) toggleOptionsVisibility();
                    }}
                >
                    <img 
                        id={arrowIconUniqueId}
                        className={"component-dropdown-arrow-icon " + 
                            (isOptionListVisible? "component-dropdown-icon_rotate ":"")} 
                        src={ic_expand_more}
                    />
                </div>

                {/* Option List */}
                {isOptionListVisible? (
                    
                    <div id={optionEleId} 
                        className={"component-dropdown-optionList "}
                        onMouseEnter={() => { setOptionTraversingIndex(undefined); }}
                    >
                        {(isArrayNotEmpty(optionArray) && !isListLoading)? optionArray:
                            (isArrayNotEmpty(optionArray)? (
                                <div className={"d-flex align-items-center justify-content-center"}>
                                    <Spinner/>
                                </div>
                            )
                        :"")}
                    </div>
                ):""}
            </div>

            {/* Error Message */}
            {isErrorPresent? (
                <div className={"component-dropdown-errorMsg"}>
                    {errorMsg_validated}
                </div>
            ):""}

        </div> 
    );
}